module.exports = __webpack_public_path__ + "img/title_6.61966812.png";